import { AlertsRoutes, ConfigureRoutes, ModuleRoutes, ReportsRoutes} from "./route.constant";

const homeMenu = {
  title: 'Home',
  name: 'dashboard',
  url: ModuleRoutes.Dashboard.Url,
  src: 'menu_home',
  isMenuVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [],
  subMenuHeader: '',
}

export const configureMenu = {
  src: 'menu_configure',
  title: 'Configure',
  name: 'configure',
  url: null,
  isMenuVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Components',
      name: 'component',
      url: ConfigureRoutes.Components.Url,
      isMenuVisible: true,
      config: { highlight: false },
    },
    {
      title: 'Procedures',
      name: 'procedure',
      url: ConfigureRoutes.Procedures.Url,
      isMenuVisible: true,
      config: { highlight: false },
    },
    {
      title: 'Recurring Orders',
      name: 'recurring-orders',
      url: ConfigureRoutes.RecurringOrder.Url,
      isMenuVisible: true,
      config: { highlight: false },
    },
  ],
  subMenuHeader: '',
}

const patientEnrollMenu = {
  title: 'Patient Enrollment',
  name: 'patientEnrollment',
  url: ModuleRoutes.PatientEnrollment.Url,
  src: 'menu_patient_enrollment',
  isMenuVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [],
  subMenuHeader: '',
}

const reportMenu = {
  src: 'menu_report',
  title: 'Reports',
  name: 'reports',
  url: null,
  isMenuVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Invoices',
      name: 'invoices',
      url: ReportsRoutes.Invoices.Url,
      isMenuVisible: true,
      config: { highlight: false },
    },
    {
      title: 'Physician Signoff Report',
      name: 'physicianSignOff',
      url: ReportsRoutes.PhysicianSignOff.Url,
      isMenuVisible: true,
      config: { highlight: false },
    },
    {
      title: 'Order Search Report',
      name: 'advanceSearch',
      url: ReportsRoutes.OrderSearchReport.Url,
      isMenuVisible: true,
      config: { highlight: false },
    },
    {
      title: 'NDC Search Report',
      name: 'NDCReportSearch',
      url: ReportsRoutes.NDCSearchReport.Url,
      isMenuVisible: true,
      config: { highlight: false },
    },
    {
      title: 'Return Product',
      name: 'returnProduct',
      url: ReportsRoutes.ReturnProduct.Url,
      isMenuVisible: true,
      config: { highlight: false },
    },
    {
      title: '340B Order Report',
      name: 'order340bReport',
      url: ReportsRoutes.ReportFor340B.Url,
      isMenuVisible: true,
      config: { highlight: false },
    }
  ],
}

const myAccountMenu = {
  title: 'My Account',
  name: 'accountSetting',
  url: ModuleRoutes.MyAccount.Url,
  src: 'menu_account',
  isMenuVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [],
  subMenuHeader: '',
}

const alertMenu = {
  title: 'Alerts',
  name: 'alerts',
  url: ModuleRoutes.Alerts.Url,
  src: 'menu_alert',
  isMenuVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subMenuHeader: '',
  subItems: [
    {
      title: 'Manage Alerts',
      name: 'alerts',
      url: AlertsRoutes.ManageAlerts.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Reservation',
      name: 'reservation',
      url: AlertsRoutes.Reservations.Url,
      isMenuVisible: true,
      config: { highlight: false }
    }, 
  ],
}

/******top navigation********/
export const menuOption = [
  homeMenu,
  configureMenu,
  patientEnrollMenu,
  reportMenu,
  myAccountMenu,
  alertMenu,
]
